<template>
	<a-drawer
		:title="drawerTitle"
		placement="right"
		:width="560"
		:visible="visible"
		:destroyOnClose="true"
		@close="onClose"
	>
		<a-spin :spinning="loading">
			<a-form-model ref="oddsForm" :model="form" layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" autoComplete="off">
				<a-tabs default-active-key="1">
					<a-tab-pane key="1" tab="和值" :forceRender="true">
						<a-form-model-item
							v-for="item in hezhiBetList"
							:key="item.id"
							:label="item.name"
							:prop="'item' + item.id"
							:rules="[{ validator: validateOdds, trigger: 'blur' }]"
						>
							<a-input v-model="form['item' + item.id].odds" addon-before="赔率" />
						</a-form-model-item>
					</a-tab-pane>
					<a-tab-pane key="2" tab="百值" :forceRender="true">
						<a-form-model-item
							v-for="item in baizhiBetList"
							:key="item.id"
							:label="item.name"
							:prop="'item' + item.id"
							:rules="[{ validator: validateOdds, trigger: 'blur' }]"
						>
							<a-input v-model="form['item' + item.id].odds" addon-before="赔率" />
						</a-form-model-item>
					</a-tab-pane>
					<a-tab-pane key="3" tab="十值" :forceRender="true">
						<a-form-model-item
							v-for="item in shizhiBetList"
							:key="item.id"
							:label="item.name"
							:prop="'item' + item.id"
							:rules="[{ validator: validateOdds, trigger: 'blur' }]"
						>
							<a-input v-model="form['item' + item.id].odds" addon-before="赔率" />
						</a-form-model-item>
					</a-tab-pane>
					<a-tab-pane key="4" tab="个值" :forceRender="true">
						<a-form-model-item
							v-for="item in gezhiBetList"
							:key="item.id"
							:label="item.name"
							:prop="'item' + item.id"
							:rules="[{ validator: validateOdds, trigger: 'blur' }]"
						>
							<a-input v-model="form['item' + item.id].odds" addon-before="赔率" />
						</a-form-model-item>
					</a-tab-pane>
				</a-tabs>
			</a-form-model>
		</a-spin>

		<div class="drawer-footer">
			<a-button style="margin-right: 8px;" @click="onClose">取消</a-button>
			<a-button type="primary" :loading="submitLoading" @click="onSubmit">保存</a-button>
		</div>
	</a-drawer>
</template>

<script>
import { lottoBetList, lottoBetUpdate } from '@/api/op/lottoBet';

export default {
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		user: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			loading: false,
			submitLoading: false,
			hezhiBetList: [],
			baizhiBetList: [],
			shizhiBetList: [],
			gezhiBetList: [],
			form: {},
		};
	},
	computed: {
		rootId() {
			return Number((this.user && this.user.id) || 0);
		},
		drawerTitle() {
			if (!this.user) {
				return '设置赔率';
			}
			const name = this.user.nickname || this.user.loginAccount || '';
			return `设置赔率 - ${name} (#${this.user.id})`;
		},
	},
	watch: {
		visible(val) {
			if (val && this.rootId > 0) {
				this.loadData();
			}
		},
	},
	methods: {
		loadData() {
			this.loading = true;
			lottoBetList(this.rootId).then((res) => {
				this.hezhiBetList = res.data.hezhiBetList || [];
				this.baizhiBetList = res.data.baizhiBetList || [];
				this.shizhiBetList = res.data.shizhiBetList || [];
				this.gezhiBetList = res.data.gezhiBetList || [];
				this.form = res.data.form || {};
			}).finally(() => {
				this.loading = false;
			});
		},
		onClose() {
			this.$emit('cancel');
		},
		onSubmit() {
			this.$refs.oddsForm.validate((valid) => {
				if (!valid) {
					this.$message.error('表单填写错误，请校验后再提交');
					return;
				}
				this.submitLoading = true;
				lottoBetUpdate(this.form, this.rootId).then(() => {
					this.$message.success('修改成功');
					this.$emit('ok');
				}).finally(() => {
					this.submitLoading = false;
				});
			});
		},
		validateOdds(rule, value, callback) {
			if (!value || value.odds === '' || value.odds === null || value.odds === undefined) {
				callback(new Error('赔率不能为空'));
				return;
			}
			const odds = Number(value.odds);
			if (isNaN(odds) || odds <= 0) {
				callback(new Error('请填写有效赔率'));
				return;
			}
			callback();
		},
	},
};
</script>

<style lang="less" scoped>
.drawer-footer {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 100%;
	border-top: 1px solid #e8e8e8;
	padding: 10px 16px;
	background: #fff;
	text-align: right;
	z-index: 1;
}

/deep/ .ant-drawer-body {
	padding-bottom: 64px;
}
</style>
